<template lang="pug">
section
  .container.my-10
    h2.text-ro 商品展示
    swiper.py-5(:options="swiperOption")
      swiper-slide.border.p-2(v-for="item in products", :key="item.item_id")
        .shop-top.text-center
          .badge.badge-danger.category-top {{ item.type_name }}
          img.shop-img(
            :src="`http://res.99ro.top/assets/collection/${item.item_id}.gif`",
            onerror="this.src='http://res.99ro.top/assets/collection/default.gif'",
            style="margin-bottom:10px;"
          )
        .shop-content
          h6
            span.text-ro {{ item.item_name }}
          //- p.text-left.p-3.text-description
          //-   | {{item.item_desctable}}
          .d-flex.justify-content-between
            span.text-ro-dark 售价 {{ item.cash }} Vis
            small(style="padding-top:3px;") 奖励 {{ item.rebatetoken }} 返利币
        .shop-footer
          .d-flex.justify-content-center.align-items-center
            router-link.btn.btn-outline-ro.w-50(:to="'/detailed/' + item.item_id")
              | 查看详情
    .text-center
      router-link.btn.btn-ro.text-white(:to="{ name: 'Products' }")
        | 查看更多商品
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import * as shopAPI from '@/api/shop';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      products: [],
      status: {
        loadingID: '',
      },
      // counts: 0,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 5,
        speed: 600,
        autoplay: {
          delay: 5000,
        },
        breakpoints:
        {
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
  methods: {
    getProducts() {
      const vm = this;
      shopAPI.getList().then((data) => {
        //  vm.products = response.data.products;
        vm.products = data.filter((item) => { return item._type == "card" });
        // console.log(vm.products);
      })
    },
  },
  created() {
    this.getProducts();
  },
};
</script>

<style lang="scss" scoped>
.shop-top {
  position: relative;
  .category-top {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.shop-content {
  height: 60px;
  // .text-description{
  //   height: 120px;
  //   overflow-y: auto;
  // }
}
.shop-img {
  width: 150px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Shop.vue